import React, { useEffect, useState , useRef } from "react";
import FoodItem from "./FoodItem";
import { useInView } from 'react-intersection-observer'
import {
  Link,
  useLocation,
  useOutletContext,
  useNavigate,
} from "react-router-dom";
import { kindFood } from "../assetss/data/kindFood";

const ChoosFoodCart = ({idName , title , kinds , setActive}) => {
  const [ref , inView] = useInView({rootMargin:'-128px 0px -128px 0px'})
  useEffect(() => {
    if (inView) {
      console.log(idName)
      localStorage.setItem('visible' , idName)
      setActive(idName)
    }
  }, [inView , idName , setActive])
  // console.log(
  const location = useLocation();
  const navigate = useNavigate();
  const { searchQuery } = useOutletContext();
  const target = idName;
  // const ref = ref
  const filteredProducts = kinds.filter((product) => {
    // console.log(product)
    return product.title.includes(searchQuery);
  });
  // console.log(kind)
  useEffect((target) => {
    if ((location.pathname = location.state)) {
      window.location.href = "#" + location.state.target;
      //   // navigate(`/chooseFood#${location.state.target}`)
      // window.location.href = window.location.href;
    }
  }, []);

  return (
    <>
      <div ref={ref} className="scroll-mt-32 section " id={idName}>
        {!searchQuery && (
          <p
            className="text-center py-1 font-bold text-lg  
         dark:text-white"
          >
            {title}
          </p>
        )}
        {filteredProducts.map((food) => {
          return <FoodItem food={food} key={food.id} />;
        })}
      </div>
    </>
  );
};

export default ChoosFoodCart;
